import { NgModule } from '@angular/core';

import { CarroComprasProvider } from './providers/services/carro-compras/carro-compras.provider';
import { CarroComprasService } from './services/carro-compras.service';

import { RutFormatterProvider } from './providers/services/rut-formatter/rut-formatter.provider';
import { RutFormatterService } from './services/rut-formatter.service';

import { TokenSaverProvider } from './providers/services/token-saver/token-saver.provider';
import { TokenSaverService } from './services/token-saver.service';

import { DialogServiceProvider } from './providers/services/dialog/dialog.provider';
import { DialogService } from './services/dialog.service';

import { StorageService } from 'src/app/global/services/storage.service';
// import { StorageServiceProvider } from "src/app/global/providers/services/storage/storage.service.provider";
import { AgendaProviderVM } from './providers/services/agenda-vm/agenda-vm.provider';
import { AnexoContratoProviderVM } from './providers/services/anexo-contrato/anexo-contrato.provider';
import { AuthVmProvider } from './providers/services/auth-vm/auth-vm.provider';
import { BancoProviderVM } from './providers/services/banco/banco-vm.provider';
import { CartaPoderProviderVM } from './providers/services/carta-poder-vm/carta-poder-vm.provider';
import { ContactoProviderVM } from './providers/services/contacto/contacto.provider';
import { CuentaAbonoProviderVM } from './providers/services/cuenta-abono-vm/cuenta-abono-vm.provider';
import { CuotasProviderVM } from './providers/services/cuotas/cuotas.provider';
import { DatosComercioProviderVM } from './providers/services/datos-comercio/datos-comercio.provider';
import { DatosPersonalesVM } from './providers/services/datos-personales/datos-personales.provider';
import { DeclaracionJuradaProviderVM } from './providers/services/declaracion-jurada/declaracion-jurada.provider';
import { DocumentVMProvider } from './providers/services/document-vm/document-vm.provider';
import { FirmaProviderVM } from './providers/services/firma/firma.provider';
import { GoToPaso3ProviderVM } from './providers/services/gotopaso3-vm/go-to-paso3-vm.provider';
import { InstalacionDireccionProviderVM } from './providers/services/instalacion-direccion/instalacion-direccion.provider';
import { LocalStorageProviderVM } from './providers/services/localstorage/localstorage.provider';
import { MarketplaceRedirectProvider } from './providers/services/marketplace-redirect/marketplace-redirect.provider';
import { NotificacionCorreoProviderVM } from './providers/services/notificacion-correo-vm/notificacion-correo-vm.provider';
import { PayProcessProviderVM } from './providers/services/payProcess/pay-process.provider';
import { ProductosVM } from './providers/services/productos/productos.provider';
import { ProveedorProviderVM } from './providers/services/proveedores-vm/proveedor-vm.provider';
import { ResumenProviderVM } from './providers/services/resumen/resumen-vm.provider';
import { SiguientesPasosProviderVM } from './providers/services/siguientes-pasos-vm/siguientes-pasos-vm.provider';
import { StepperProviderVM } from './providers/services/stepper-vm/stepper-vm.provider';
import { UafProviderVM } from './providers/services/uaf-vm/uaf-vm.provider';
import { ValidacionEdicionProviderVM } from './providers/services/validacion-edicion/validacion-edicion.provider';
import { AgendaServiceVM } from './services/agenda-vm.service';
import { AnexoContratoServiceVM } from './services/anexo-contrato.service';
import { AuthVMService } from './services/auth-vm.service';
import { BancoServiceVM } from './services/banco-vm.service';
import { CartaPoderServiceVM } from './services/carta-poder-vm-service';
import { ContactoServiceVM } from './services/contacto.service';
import { CuentaAbonoServiceVM } from './services/cuenta-abono-vm.service';
import { CuotasServiceVM } from './services/cuotas.service';
import { DatosComercioServiceVM } from './services/datos-comercio.service';
import { DatosPersonalesService } from './services/datos-personales.service';
import { DeclaracionJuradaServiceVM } from './services/declaracion-jurada.service';
import { DocumentVMService } from './services/document-vm.service';
import { FirmaServiceVM } from './services/firma.service';
import { GoToPaso3ServiceVM } from './services/go-to-paso3.service';
import { InstalacionDireccionServiceVM } from './services/instalacion-direccion.service';
import { LocalStorageServiceVM } from './services/localstorage.service';
import { MarketplaceRedirectService } from './services/marketplace-redirect-vm.service';
import { NotificacionCorreoServiceVM } from './services/notificacion-correo-vm.service';
import { PayProcessServiceVM } from './services/pay-process.service';
import { vmProductosService } from './services/productos.service';
import { ProveedorServiceVM } from './services/proveedor-vm.service';
import { ResumenServiceVM } from './services/resumen-vm.service';
import { SiguientesPasosServiceVM } from './services/siguientes-pasos-vm.service';
import { StepperServiceVM } from './services/stepper-vm.service';
import { UafServiceVM } from './services/uaf-vm.service';
import { ValidacionEdicionServiceVM } from './services/validacion-edicion.service';


@NgModule({
    providers: [
        {
            provide: CarroComprasService,
            useClass: CarroComprasProvider
        },
        {
            provide: RutFormatterService,
            useClass: RutFormatterProvider
        },
        {
            provide: NotificacionCorreoServiceVM,
            useClass: NotificacionCorreoProviderVM
        },
        {
            provide: TokenSaverService,
            useClass: TokenSaverProvider
        },
        {
            provide: DialogService,
            useClass: DialogServiceProvider
        },
        {
            provide: StorageService,
            useClass: StorageService
        },
        {
            provide: vmProductosService,
            useClass: ProductosVM
        },
        {
            provide: DatosPersonalesService,
            useClass: DatosPersonalesVM
        },
        {
            provide: MarketplaceRedirectService,
            useClass: MarketplaceRedirectProvider
        },
        {
            provide: AuthVMService,
            useClass: AuthVmProvider
        },
        {
            provide: ValidacionEdicionServiceVM,
            useClass: ValidacionEdicionProviderVM
        },
        {
            provide: InstalacionDireccionServiceVM,
            useClass: InstalacionDireccionProviderVM
        },
        {
            provide: DeclaracionJuradaServiceVM,
            useClass: DeclaracionJuradaProviderVM
        },
        {
            provide: CuotasServiceVM,
            useClass: CuotasProviderVM
        },
        {
            provide: ContactoServiceVM,
            useClass: ContactoProviderVM
        },
        {
            provide: AnexoContratoServiceVM,
            useClass: AnexoContratoProviderVM
        },
        {
            provide: AgendaServiceVM,
            useClass: AgendaProviderVM
        },
        {
            provide: CuentaAbonoServiceVM,
            useClass: CuentaAbonoProviderVM
        },
        {
            provide: DatosComercioServiceVM,
            useClass: DatosComercioProviderVM
        },
        {
            provide: DocumentVMService,
            useClass: DocumentVMProvider
        },
        {
            provide: BancoServiceVM,
            useClass: BancoProviderVM
        },
        {
            provide: CartaPoderServiceVM,
            useClass: CartaPoderProviderVM
        },
        {
            provide: StepperServiceVM,
            useClass: StepperProviderVM
        },
        {
            provide: LocalStorageServiceVM,
            useClass: LocalStorageProviderVM
        },
        {
            provide: GoToPaso3ServiceVM,
            useClass: GoToPaso3ProviderVM
        },
        {
            provide: ResumenServiceVM,
            useClass: ResumenProviderVM
        },
        {
            provide: FirmaServiceVM,
            useClass: FirmaProviderVM
        },
        {
            provide: PayProcessServiceVM,
            useClass: PayProcessProviderVM
        },
        {
            provide: SiguientesPasosServiceVM,
            useClass: SiguientesPasosProviderVM
        },
        {
            provide: UafServiceVM,
            useClass: UafProviderVM
        },
        {
            provide: ProveedorServiceVM,
            useClass: ProveedorProviderVM
        }
    ]
})
export class ViewModelModule { }
